import React from 'react';
import AppIcon from '../utils/AppIcon';
import { IconName } from '../utils/AppIcon';

interface WelcomeScreenProps {
    newMessage: string;
    onNewMessageChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onKeyPress: (e: React.KeyboardEvent) => void;
    onSend: () => void;
    disabled?: boolean;
    isConnected?: boolean;
}

const cardData = [
    {
        icon: 'product_ico_f' as IconName,
        title: 'Product',
        description: 'How many products will be available next month, broken down by brand?'
    },
    {
        icon: 'concept_ico_f' as IconName,
        title: 'Concept',
        description: 'Give me the licensee with the least number of concepts linked to products proportionally'
    },
    {
        icon: 'revenue_ico_f' as IconName,
        title: 'Revenue History',
        description: 'Give me a list of the top 10 performing licensees by revenue for the  last 12 months'
    },
    {
        icon: 'retail_ico_f' as IconName,
        title: 'Retail Listings',
        description: 'How many listings are at Retailer Target for Brand Paw Patrol in 2025?'
    }
];

const WelcomeScreen: React.FC<WelcomeScreenProps> = ({
                                                         newMessage,
                                                         onNewMessageChange,
                                                         onKeyPress,
                                                         onSend,
                                                         disabled = false,
                                                         isConnected = true
                                                     }) => {
    return (
        <div className="flex flex-col h-full">
            <div className="flex-1 overflow-y-auto">
                <div className="flex flex-col items-center justify-center p-6 max-w-4xl mx-auto h-full">

                    <div className="text-center mb-8">
                        <div className="flex justify-center mb-4">
                            <img
                                src="/images/icons/alex_ai_bot.svg"
                                alt="Alex AI Bot"
                                className="w-24 h-24"
                            />
                        </div>
                        <h1 className="text-2xl font-semibold text-gray-800 mb-2">
                            I am Alex, your Xelacore data copilot.
                        </h1>
                        <p className="text-[#888888] text-sm">
                            Here are a few examples of what you can ask me
                        </p>
                        {!isConnected && (
                            <div className="mt-3 px-4 py-2 bg-yellow-50 text-yellow-700 rounded-lg border border-yellow-200 flex items-center">
                                <div className="h-2 w-2 bg-red-500 rounded-full mr-2"></div>
                                <p className="text-sm">
                                    Not connected to AI service. Return to the home page to connect before asking questions.
                                </p>
                            </div>
                        )}
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl w-full mb-8">
                        {cardData.map((card, index) => (
                            <div key={index} className="bg-[#333351] rounded-2xl p-6 text-white">
                                <div className="flex flex-col mb-3">
                                    <AppIcon name={card.icon} size={24} className="mb-2" />
                                    <h2 className="text-lg font-medium text-left">{card.title}</h2>
                                </div>
                                <p className="text-gray-300 text-sm text-left">
                                    {card.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WelcomeScreen;